import ReactDOM from 'react-dom';
import React from 'react';

import loadTranslations from '@utils/localeSetup';
import Footer from './Footer';
import { NavigationProvider } from './context/NavigationContext';
import { SiteSettingsProvider } from './context/SiteSettingsContext';

(async () => {
  const rootElement = document.getElementById('footer-root');
  await loadTranslations();

  if (rootElement) {
    ReactDOM.render(
      <SiteSettingsProvider>
        <NavigationProvider>
          <Footer />
        </NavigationProvider>
      </SiteSettingsProvider>,
      rootElement
    );
  }
})();
